import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import sessionStorage from "sessionstorage";
import $ from "jquery";

//css
import "../Assets/Css/bootstrap/css/bootstrap.min.css";
import "../Assets/icon/themify-icons/themify-icons.css";
import "../Assets/icon/icofont/css/icofont.css";
import "../Assets/icon/font-awesome/css/font-awesome.min.css";
import "../Assets/Css/font-awesome-n.min.css";
import "../Assets/Css/font-awesome.min.css";
import "../Assets/Css/jquery-ui.css";
import "../Assets/Css/style.css";
import "../Assets/Css/style-.css";
import "../Assets/Css/responsive.css";
import "../Assets/Css/NewCss/styleNew.css";
import "../Assets/Css/wollemi.css";
import "../Assets/Css/ProjectList.css";
import "../Assets/Css/InputScreen.css";
import "../Assets/Css/OutputScreen.css";
import "../Assets/Css/HumimicLogin.css";
import "../Assets/Css/OpportunityLandscape.css";
import "../Assets/Css/MobileAdaptive.css";
import "../Assets/Css/zoom-responsive.css";

import { applyZoomScaleDirect } from "../customHooks/useZoomScale";
import { setupSessionInterceptor } from "../Components/Utility/sessionUtils";
import { UiPaths } from "../UiPaths";
import HumimicLoader from "../Common/HumimicLoader";

// Immediately apply zoom scale and setup session interceptor before initial render
if (typeof window !== "undefined") {
  applyZoomScaleDirect();
  setupSessionInterceptor();
}

const lazyRetry = function (componentImport, name) {
  // a function to retry loading a chunk to avoid chunk load error out of date code
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      // check if the window has already been refreshed
      window.sessionStorage.getItem(`retry${name}-lazy-refreshed`) || "false"
    );

    componentImport()
      .then((component) => {
        // try to import the component
        window.sessionStorage.setItem(`retry${name}-lazy-refreshed`, "false"); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem(`retry${name}-lazy-refreshed`, "true"); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};

const Login = React.lazy(() =>
  lazyRetry(() => import("../App/Home/Home.js"), "login")
);
const OtherRoutes = React.lazy(() =>
  lazyRetry(() => import("../Routes/OtherRoutes"), "otherRoutes")
);
const ForgetPasswordReset = React.lazy(() =>
  lazyRetry(() => import("../App/Home/ForgetPasswordReset"), "resetPass")
);

function ProtectedRoute() {
  useLocation(); // subscribe to location changes so session check re-evaluates
  return sessionStorage.getItem("sessionItem") === null ? (
    <Navigate to={UiPaths.HOME} />
  ) : (
    <OtherRoutes />
  );
}

export default class HomeEntryRoute extends React.Component {
  componentDidMount() {
    // Apply zoom-responsive scaling (keeps design intact at 110%, 125%, 150% zoom)
    this._cleanupZoomScale = applyZoomScaleDirect();

    // If mobile view, ensure platform does not stay in browser fullscreen
    const exitFsIfMobile = () => {
      if (
        typeof window !== "undefined" &&
        (window.innerWidth <= 900 ||
          window.innerHeight <= 550 ||
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
      ) {
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen().catch(() => {});
        }
      }
    };
    exitFsIfMobile();

    this._handleMobileFs = exitFsIfMobile;
    window.addEventListener("resize", this._handleMobileFs);
    window.addEventListener("orientationchange", this._handleMobileFs);

    $(document).on("keypress", function (event) {
      if (
        event.target.id === "singleModalSearchIdActive" ||
        event.target.name === "singleModalSearchIdActive"
      ) {
        if (
          event.key.toLowerCase() === "enter" &&
          typeof document._handleDidYouMean === "function"
        ) {
          document._handleDidYouMean();
        }
      } else if (!$(event.target).is("textarea")) {
        if (event.key.toLowerCase() === "enter") {
          event.preventDefault();
        }
      }
    });

    // document.addEventListener('contextmenu', (e) => {//disable right click
    //      e.preventDefault();
    // });
  }

  componentWillUnmount() {
    // Clean up zoom-scale resize listener
    if (typeof this._cleanupZoomScale === "function") {
      this._cleanupZoomScale();
    }
    if (typeof this._handleMobileFs === "function") {
      window.removeEventListener("resize", this._handleMobileFs);
      window.removeEventListener("orientationchange", this._handleMobileFs);
    }
  }

  render() {
    return (
      <Router basename={`${UiPaths.HOME}`}>
        <Suspense
          fallback={
            <div className="loader center">
              <HumimicLoader size="105px" />
            </div>
          }
        >
          <Routes>
            {/*LOGIN-ROUTES*/}
            <Route
              path={`${process.env.PUBLIC_URL}${UiPaths.HOME}`}
              element={<Login />}
              
            />
            <Route
              path={`${process.env.PUBLIC_URL}${UiPaths.RESET_PASSWORD}`} 
              element={<ForgetPasswordReset />}
            />
            <Route path="/about.html" element={<div />} />
            <Route path="/privacy-guidelines.html" element={<div />} />
            <Route path="/security-framework.html" element={<div />} />
            <Route path="/terms-of-use.html" element={<div />} />
            <Route path="/expertise.html" element={<div />} />
            <Route path="/use-cases.html" element={<div />} />
            <Route path="/fact-sheet.html" element={<div />} />
            <Route path="/know-us-better.html" element={<div />} />
            {/*PROTECTED-ROUTES*/}
            <Route
              path="/*"
              element={<ProtectedRoute />}
            />
          </Routes>
        </Suspense>
      </Router>
    );
  }
}
